'use client';

import { Textarea } from '@coolblue-development/freddy';
import enterApplicationDetailsTrigger from '@coolblue-development/ga4-events/triggers/VacancyApplicationForm/enterApplicationDetailsTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { Rules } from '@sharedTypes';
import { useFormContext } from 'react-hook-form';

import { FormLabelWithInfo } from './FormLabelWithInfo';

type Props = {
  name: string;
  label: string;
  placeholder: string;
  rules?: Rules;
  info?: string;
};

export const TextAreaHelper = ({ name, label, placeholder, rules, info }: Props) => {
  const {
    register,
    setValue,
    formState: { errors, isLoading }
  } = useFormContext();

  const { trackEvent } = useAnalytics();

  const errorMessage = errors[name]?.message;
  if (errorMessage) {
    trackEvent(
      enterApplicationDetailsTrigger({
        input_field: label,
        status: 'failure',
        content: errorMessage.toString()
      })
    );
  }

  return (
    <FormLabelWithInfo label={label} info={info} htmlFor={name}>
      <Textarea
        {...register(name, {
          ...rules,
          validate: undefined
        })}
        id={name}
        onFocus={() => {
          trackEvent(
            enterApplicationDetailsTrigger({
              input_field: label,
              status: 'focus',
              content: ''
            })
          );
        }}
        autosize
        onChange={event => setValue(name, event.target.value)}
        validation={errorMessage ? 'error' : undefined}
        placeholder={placeholder}
        helperText={errorMessage as string | undefined}
        disabled={isLoading}
      />
    </FormLabelWithInfo>
  );
};
